var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("YDSearchForm", {
        attrs: {
          "form-items": _vm.filteredSearchItems,
          "initial-values": _vm.initVals,
          "show-add": _vm.showAddButton,
          permi: "user_advertising_edit",
          useCache: _vm.useCache,
          "cache-options": {
            type: "session",
            key: "bannerListParams",
          },
        },
        on: {
          search: _vm.handleSearch,
          reset: _vm.handleReset,
          add: _vm.addBanner,
        },
        scopedSlots: _vm._u([
          {
            key: "areaSlot",
            fn: function (ref) {
              var formData = ref.formData
              return [
                _c("YdCitySelect", {
                  attrs: {
                    mode: "1",
                    placeholder: "请选择地级归属",
                    customHttp: _vm.getDriverAreaTree,
                    fieldFormat: _vm.fieldFormat,
                  },
                  model: {
                    value: formData.areaCode,
                    callback: function ($$v) {
                      _vm.$set(formData, "areaCode", $$v)
                    },
                    expression: "formData.areaCode",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _vm._t("operation-area"),
      _c(
        "yd-table",
        {
          ref: "bannerTable",
          attrs: {
            data: _vm.tableData,
            pagination: _vm.pagination,
            loading: _vm.loading,
            "span-method": _vm.handleSpanMethod,
          },
          on: {
            onChange: _vm.onTableChange,
            "selection-change": _vm.handleSelectionChange,
          },
        },
        [
          _vm.customTableConfig.showSelection
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "Banner名称",
              align: "center",
              "min-width": "150px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.id))]),
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.showBannerDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bannerGroupName",
              label: "所属广告组",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(_vm._s(row.bannerGroupName))]),
                    _c(
                      "span",
                      {
                        class: [
                          "status-text",
                          "status-" + row.bannerGroupStatus,
                        ],
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getAdGroupStatusMap({
                                state: row.bannerGroupStatus,
                              })
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "displayPage", label: "展示页面", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "slotKey", label: "组内位置", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getBannerPosition({ slotKey: row.slotKey })
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "sort",
              label: "权重",
              width: "80",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "图片", "min-width": "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.imgUrl
                      ? _c("el-image", {
                          staticStyle: { width: "60px", height: "60px" },
                          attrs: {
                            src: scope.row.imgUrl,
                            fit: "cover",
                            "preview-src-list": [scope.row.imgUrl],
                          },
                        })
                      : _vm._e(),
                    scope.row.marketImgUrl
                      ? _c("el-image", {
                          staticStyle: {
                            width: "60px",
                            height: "60px",
                            "margin-left": "5px",
                          },
                          attrs: {
                            src: scope.row.imgUrl,
                            fit: "cover",
                            "preview-src-list": [scope.row.marketImgUrl],
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "展示渠道", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatDisplayChannel(scope.row.displayChannel)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "展示地区",
              align: "center",
              width: "200px",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "180px",
                          "white-space": "nowrap",
                          "text-overflow": "ellipsis",
                          overflow: "hidden",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              row.allArea === 1
                                ? "全部"
                                : row.areaNameList
                                ? row.areaNameList.join(",")
                                : ""
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "状态", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.renderStatusTag(scope.row.status).type,
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.renderStatusTag(scope.row.status).text) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "开始时间", width: "160", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.startTime) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "结束时间", width: "160", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.endTime) + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200", align: "center" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._t(
                        "operation",
                        function () {
                          return [
                            _vm.btnBold("edit", scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editBanner(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            编辑\n          ")]
                                )
                              : _vm._e(),
                            _vm.btnBold("pass", scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeStatus(999, scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            通过\n          ")]
                                )
                              : _vm._e(),
                            _vm.btnBold("noPass", scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "danger-button",
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeStatus(2, scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            不通过\n          ")]
                                )
                              : _vm._e(),
                            _vm.btnBold("offLine", scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "danger-button",
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeStatus(5, scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            下架\n          ")]
                                )
                              : _vm._e(),
                            _vm.btnBold("onLine", scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeStatus(998, scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            上架\n          ")]
                                )
                              : _vm._e(),
                            _vm.btnBold("data", scope.row)
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dataView(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("数据")]
                                )
                              : _vm._e(),
                          ]
                        },
                        { row: scope.row }
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm.editVisible
        ? _c("bannerEdit", {
            attrs: {
              visible: _vm.editVisible,
              title: _vm.currentBanner ? "编辑" : "新增",
              "is-edit": !!_vm.currentBanner,
              "edit-data": _vm.currentBanner,
              "ad-group-id": _vm.extraQueryParams.bannerGroupId,
              "template-id": _vm.extraQueryParams.templateId,
              displayPageName: _vm.extraQueryParams.displayPageName,
            },
            on: {
              "update:visible": function ($event) {
                _vm.editVisible = $event
              },
              success: _vm.success,
            },
          })
        : _vm._e(),
      _c("RejectDialog", {
        attrs: {
          visible: _vm.rejectDialogVisible,
          bannerId: _vm.currentBanner ? _vm.currentBanner.id : "",
        },
        on: {
          "update:visible": function ($event) {
            _vm.rejectDialogVisible = $event
          },
          confirm: _vm.handleRejectConfirm,
        },
      }),
      _c("TimeModifyDialog", {
        attrs: {
          visible: _vm.timeModifyDialogVisible,
          bannerId: _vm.currentBanner ? _vm.currentBanner.id : "",
          currentStartTime: _vm.currentBanner
            ? _vm.currentBanner.startTime
            : "",
          currentEndTime: _vm.currentBanner ? _vm.currentBanner.endTime : "",
        },
        on: {
          "update:visible": function ($event) {
            _vm.timeModifyDialogVisible = $event
          },
          confirm: _vm.handleTimeModifyConfirm,
        },
      }),
      _c("BannerDetail", {
        attrs: { visible: _vm.detailVisible, "banner-id": _vm.bannerId },
        on: {
          "update:visible": function ($event) {
            _vm.detailVisible = $event
          },
        },
      }),
      _c("data-view", { ref: "dataView" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }